<template>
  <v-app :class="{ 'safety-assistant-app': safetyAssistant }">
    <v-main>
      <router-view />
    </v-main>
    <NotificationSnack />
  </v-app>
</template>

<script>
import NotificationSnack from '@/components/common/NotificationSnack.vue'
import eventTracker from '@/mixins/eventTracker'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    NotificationSnack,
  },
  mixins: [eventTracker],
  computed: {
    ...mapGetters({
      safetyAssistant: 'safetyAssistant',
    }),
  },
  created() {
    this.initTracking()
    const queryString = window.location.search
    if (queryString) {
      this.setURLParam(queryString)
    }
  },
  methods: {
    ...mapActions({
      setURLParam: 'setURLParam',
    }),
  },
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap')
@import "~@/style/global.scss"
.theme--light.v-card.action-card
  background-color: white
.container.fill-height
  align-content: center
.bg-dark
  background-color: $black

.theme--dark
  .v-card
    h3, h2, h1
      color: $white !important
    .v-card-text
      color: $white !important
  .v-text-field
    .v-input__control .v-input__slot
      background-color: $darkBackground !important
      fieldset
        border-color: $darkBorder !important
    &:hover .v-input__control .v-input__slot fieldset
      border-color: $darkBorderHover !important
    input
      color: $white !important
      caret-color: $white !important
    .v-label
      color: $textMuted !important
    .v-icon
      color: $textMuted !important

.safety-assistant-app
  background-color: $darkBackground !important
  overflow: hidden !important
  .v-main
    background-color: $darkBackground !important
    padding: 0 !important
    overflow: hidden !important
    > .v-main__wrap
      padding: 0 !important

  .v-card
    background-color: $darkCard !important
    border: 1px solid $darkBorder !important
    color: $white !important
    box-shadow: $shadowDefault !important

  .v-input, .v-text-field
    color: $white !important
    .v-label
      color: $textLight !important
    input
      color: $white !important
      background-color: $darkInputBg !important
    .v-input__slot
      background-color: $darkInputBg !important
      border-color: $darkBorder !important
      &:hover
        border-color: $darkBorderHover !important
      &:focus-within
        border-color: $primaryBlue !important

  .v-btn
    font-family: 'Inter', sans-serif !important
    &:not(.v-btn--outlined)
      background-color: $primaryBlue !important
      color: $white !important
      font-weight: 600 !important
      &:hover
        background-color: $primaryBlueHover !important
    &.v-btn--outlined
      border-color: $darkBorder !important
      color: $textLight !important
      &:hover
        border-color: $darkBorderHover !important
        background-color: $whiteOpacity5 !important

  .footer-link
    color: $primaryBlue !important
    &:hover
      color: $linkBlueHover !important
  .text--secondary
    color: $textMuted !important
  *
    font-family: 'Inter', sans-serif !important

  .v-text-field
    &.theme--light
      &:not(.v-input--has-state)
        > .v-input__control > .v-input__slot
          &:before
            border-color: $whiteOpacity42 !important
          &:hover:before
            border-color: $darkBorderFocus !important
      &.v-input--is-focused
        > .v-input__control > .v-input__slot
          &:after
            border-color: $primaryBlue !important
  .v-divider
    border-color: $darkBorder !important
</style>
